/** @format */

import styled from 'styled-components';

export const ModalContiner = styled.div`
	background: rgba(0, 0, 0, 0.6);
	z-index: 40;
	position: fixed;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100vw;
	height: 100vh;
	left: 0;
	top: 0;
`;

export const ModalWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

export const ModalWrapperLarge = styled(ModalWrapper)`
	width: 569px;
	height: 557px;
`;

export const ModalWrapperSmall = styled(ModalWrapper)`
	width: 366px;
	height: 638px;
`;

export const BodyContainer = styled.div`
	width: 100%;
	height: 100%;
	background: ${(props) => (props.background ? props.background : '#FFFFFF')};
	border-radius: 20px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 24px;
`;

export const TitleWrapper = styled.div`
	font-weight: bold;
	font-size: 20px;
	line-height: 29px;
	text-align: center;
	color: #3d392c;
	margin-top: 16px;
`;

export const ContentWrapper = styled.div`
	font-size: 14px;
	line-height: 20px;
	color: rgba(61, 57, 44, 0.8);
	margin-top: 8px;
`;

export const ButtonContainer = styled.div`
	margin-top: 16px;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const ButtonContainerLarge = styled(ButtonContainer)`
	display: inline-flex;
	& > div {
		margin: 0 8px;
		height: 42px;
		width: 155px;
	}
`;

export const ButtonContainerSmall = styled(ButtonContainer)`
	flex-direction: column;
	& > div {
		margin: 8px 0;
		height: 42px;
		width: 318px;
	}
`;

export const FooterWrapper = styled.div`
	margin-top: 24px;
	text-align: center;
	font-size: 12px;
`;

export const CloseButtonWrapper = styled.div`
	margin-top: 32px;
	background: transparent;
	display: flex;
	justify-content: center;
	align-items: center;
`;
